<template>
  <div class="info-page">
    <section class="info-page-section">
      <div class="ui-wrapper">
        <h2 class="section-title info-page-section__title">
          {{ $t('common.aboutProject') }}
        </h2>

        <div class="info-page-section__subtitle">
          {{ $t('components.info.aboutPage.subtitle') }}
        </div>
      </div>
    </section>

    <HomeOldBuy />
    <HomeOldExamination />
    <HomeOldStartSelling />
    <HomeOldServiceWork />
    <HomeOldCommunity />
    <HomeOldFourBlocks />
    <HomeOldAboutMedia />
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n();
const schemaOrg = useSchemaOrg();

useHead({
  title: `${t('common.aboutProject')} – ${t('common.OskellyOnlineStore')}`,
  meta: [
    {
      name: 'description',
      content: `${t('common.aboutProject')} – ${t('common.OskellyOnlineStore')}`,
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      children: schemaOrg,
    },
  ],
});
</script>

<style scoped lang="scss">
.info-page-section {
  padding-top: 55px;
  padding-bottom: 50px;

  @media screen and (min-width: 767px) {
    padding-top: 24px;
    padding-bottom: 70px;
  }

  &__title {
    text-align: center;
    margin-bottom: 12px;

    @media screen and (min-width: 767px) {
      margin-bottom: 16px;
    }
  }

  &__subtitle {
    display: block;
    max-width: 560px;
    margin: 0 auto;
    color: #828282;
    text-align: center;
    font-size: 12px;
    line-height: 18px;

    @media screen and (min-width: 767px) {
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>
